import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import {CurrencyFormatter, ProductColumn} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import ComponentConfig from "../../form/ComponentConfig";

class paymentForm extends React.Component {

    render() {
        const sortable = true;
        const filterable = true;
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Tranz. sz." role="idfield"/>
                    </div>
                    <div className="col-md-4 currency">
                        <TextInput name="amount" value={this.props.values.amount} formatter={CurrencyFormatter} label="Fizetendő" disabled={this.props.disabled} saveChanges={this.props.setFieldValue}/>
                    </div>
                    <div className="col-md-3">
                        <Select
                            objectValue={false}
                            optionname="paymentprovider"
                            storeType="local"
                            name="serviceprovider_type"
                            value={(this.props.values && this.props.values.serviceprovider_type) || null}
                            label="Fizetés módja"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("serviceprovider_type")}
                            disabled={this.props.disabled}
                        />
                    </div>
                    <div className="col-md-3">
                        <Select
                            objectValue={false}
                            optionname={((this.props.values && this.props.values.serviceprovider_type) || "None") + "Status"}
                            storeType="local"
                            name="status"
                            value={(this.props.values && this.props.values.status) || null}
                            label="Státusz"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("status")}
                            disabled={true}
                        />
                    </div>
                </div>
                {this.props.values.serviceprovider_type === "DelayedPayment" ? <ComponentConfig componentName="DelayedPayment">
                    {(props) => <div className="row form-row">
                        <div className="col-md-12">
                            <Select
                                objectValue={false}
                                optionname="paymentprovider"
                                storeType="local"
                                name="payment.serviceprovider_type"
                                value={(this.props.values && (this.props.values.payment || {}).serviceprovider_type) || null}
                                label="Utólagos fizetés módja"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("payment.serviceprovider_type")}
                                disabled={this.props.disabled}
                            />
                        </div>
                    </div>}
                </ComponentConfig> : null}
                {this.props.values.serviceprovider_type === "VoucherPayment" ? <ComponentConfig componentName="VoucherPayment">
                    {(props) => <div className="row form-row">
                        <div className="col-md-12">
                            <label className="control-label">Utalványok</label>
                            {
                                this.props.values[this.props.componentConfig.idfield]
                                &&
                                this.props.values.serviceprovider_id
                                ?
                                    <SelectorGrid
                                        ref={(voucherList) => this.voucherList = voucherList}
                                        {...this.props.getFieldProps("vouchers")}
                                        disabled={this.props.disabled}
                                        name="vouchers"
                                        listfieldlabel="displayname"
                                        aggregations={{
                                            fields: {
                                                "amount": {
                                                    field: "amount", type: "SUM"
                                                }
                                            }
                                        }}
                                        addRowProps={{
                                            filter: [
                                                {
                                                    field: "sold",
                                                    operator: "not isnull"
                                                },
                                                {
                                                    field: "used",
                                                    operator: "isnull"
                                                }
                                            ]
                                        }}
                                        columns={{
                                            "displayname": {
                                                ...ProductColumn("product_id"),
                                                width: 3,
                                            },
                                            "barcode": {header: 'Vonalkód', width: 3, sortable, filterable},
                                            "amount": {header: 'Összeg', width: 3, sortable, filterable, renderer: CurrencyFormatter},
                                        }}
                                        data={{[props.componentConfig.idfield]: this.props.values.serviceprovider_id}}
                                        component="VoucherPayment"
                                        orderBy={{field: "displayname", direction: "ASC"}}
                                    />
                                :
                                    <Fragment>Kérlek mentsd el az utalványok megadása előtt!</Fragment>
                            }
                        </div>
                    </div>}
                </ComponentConfig> : null}
            </form>
        );
    }
}

export default createForm(paymentForm);
